import { api } from '@services/api';


export type UpdateCreateEmployee = {
  idLogin?: string | undefined;
  nome: string;
  cpf: string;
  senha_usuario: string;
  login_usuario: string;
  administrador: boolean;
  tipo_login: 'administrativo' | 'agendamento' | 'financeiro';
  cod_contrato: string;
  rg?: string | undefined;
  usuario: string;
};
export async function updateEmployee({
  idLogin,
  nome,
  cpf,
  administrador,
  tipo_login,
  rg,
  usuario
}: UpdateCreateEmployee) {
  console.log('estou aqui no post')
  const res = await api.post('/ravim/atualizar_usuario', {
    idLogin,
    nome,
    cpf,
    administrador,
    tipo_login,
    rg,
    usuario
  });

  return res.data;
}